<script>
    import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem
  } from '@sveltestrap/sveltestrap';

  import globaldata from '/core/stores/siteData';
  import AccessModal from '/public/components/users/AccessModal.svelte';
  import WhiteLogo from '/core/components/logos/WhiteLogo.svelte';

  let isOpen = false;

  function handleUpdate(event) {
    isOpen = event.detail.isOpen;
  }

  let showLogin = false;

  function redirector() {
      window.location = '/director';
  }

</script>

<section>
<Navbar color="primary" expand="md">
    <NavbarBrand href="/" class=''>
        <div class='d-inline-block logo-container'>

            <WhiteLogo/>

        </div>
    </NavbarBrand>
    <NavbarToggler on:click={() => (isOpen = !isOpen)} />
    <Collapse {isOpen} navbar expand="md" on:update={handleUpdate}>
      
        <Nav class="ms-auto" navbar>
          
          {#if $globaldata.usr === true}            

            <NavItem>

                <button type='button' class='btn btn-info me-2' on:click={redirector}>
                    <span class='fas fa-user'></span>
                </button>
              
            </NavItem>

          {/if}

        </Nav>    
      
    </Collapse>
  </Navbar>
</section>

<style>
    .logo-container {
      width: 100px;
      height: 24px;
    }
</style>
